import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_BANK_ACCOUNT_LIST_API_ID = 'INVESTMENT/FETCH_BANK_ACCOUNT_LIST_API';

const apiCall = createApiCall(
  FETCH_BANK_ACCOUNT_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/bank-accounts`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
